// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3d-ma","imageUploader":"EGiftCard_imageUploader__1f_xm"};